/* bc-tools-sticky-bar — mirrors hero title/image/button-label and bc-tools-stats icon+title
   pairs from their already-rendered DOM (no dup content entry needed), then shows itself
   once .bc-tools-hero__actions scrolls above the viewport (same signal as BCStickyAtc in
   bc-product-detail.js). No hero on the page → anchor is missing → bar just never appears. */
(function () {
  var bar = document.querySelector('[data-bc-sticky-bar]');
  var anchor = document.querySelector('.bc-tools-hero__actions');
  if (!bar || !anchor) return;

  var heroHeading = document.querySelector('.bc-tools-hero__heading');
  var title = bar.querySelector('[data-bc-sticky-title]');
  if (title && heroHeading) title.textContent = heroHeading.textContent.trim();

  var thumb = bar.querySelector('[data-bc-sticky-thumb]');
  var heroImage = document.querySelector('.bc-tools-hero__media-image');
  var heroPlaceholder = document.querySelector('.bc-tools-hero__media-placeholder');
  if (thumb && heroImage && heroImage.tagName === 'IMG') {
    var img = document.createElement('img');
    img.className = 'bc-tools-sticky-bar__thumb-image';
    img.src = heroImage.currentSrc || heroImage.src;
    img.alt = heroImage.alt || '';
    img.loading = 'lazy';
    thumb.appendChild(img);
  } else if (thumb && heroPlaceholder) {
    var placeholder = heroPlaceholder.cloneNode(true);
    /* Drop the hero's own class — its CSS positions the placeholder absolute/inset:0
       for hero's own box, which would blow this one up to fill the sticky bar. */
    placeholder.setAttribute('class', 'bc-tools-sticky-bar__thumb-placeholder');
    thumb.appendChild(placeholder);
  }

  var heroBtnLabel = document.querySelector('.bc-tools-hero__button .bc-button__label');
  var stickyLabel = bar.querySelector('[data-bc-sticky-cta] .bc-button__label');
  if (stickyLabel && heroBtnLabel) stickyLabel.textContent = heroBtnLabel.textContent.trim();

  var statsWrap = bar.querySelector('[data-bc-sticky-stats]');
  var statItems = document.querySelectorAll('.bc-tools-stats__inner--desktop .bc-tools-stats__item');
  if (statsWrap && statItems.length) {
    statItems.forEach(function (item) {
      var icon = item.querySelector('.bc-tools-stats__icon svg');
      var label = item.querySelector('.bc-tools-stats__title');
      if (!icon || !label) return;

      var stat = document.createElement('div');
      stat.className = 'bc-tools-sticky-bar__stat';

      var iconWrap = document.createElement('span');
      iconWrap.className = 'bc-tools-sticky-bar__stat-icon';
      iconWrap.appendChild(icon.cloneNode(true));

      var labelSpan = document.createElement('span');
      labelSpan.className = 'bc-tools-sticky-bar__stat-label';
      labelSpan.textContent = label.textContent.trim();

      stat.appendChild(iconWrap);
      stat.appendChild(labelSpan);
      statsWrap.appendChild(stat);
    });
    statsWrap.hidden = false;
  }

  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (!entry) return;
    var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', scrolledPast);
    bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
  }, { threshold: 0 });
  io.observe(anchor);
})();
